import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateZone } from '../../redux/zone/zone_actions';

const mapStateToProps = state => ({
  isDuplicating: state.zone.isDuplicating,
  errorMessage: state.zone.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateZone(id, name))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/ZoneDuplicateModal.js